import { __awaiter, __generator } from "tslib";
var VELT_SDK_VERSION = '4.3.0-beta.6';
var loadVelt = function (options) {
    return new Promise(function (resolve, reject) {
        var existingScript = document.getElementById('veltScript');
        var staging = false;
        var develop = false;
        var version = 'latest';
        var proxyDomain = '';
        if (options) {
            if (options.staging) {
                staging = options.staging;
            }
            if (options.version) {
                version = options.version;
            }
            if (options.develop) {
                develop = options.develop;
            }
            if (options.proxyDomain) {
                proxyDomain = options.proxyDomain;
            }
        }
        if (!(options === null || options === void 0 ? void 0 : options.version)) {
            version = VELT_SDK_VERSION;
        }
        if (!existingScript) {
            var script = document.createElement('script');
            if (staging) {
                script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-staging&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
            }
            else if (develop) {
                script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-dev&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
            }
            else {
                if (proxyDomain) {
                    // remove trailing slash from proxy
                    if (proxyDomain[proxyDomain.length - 1] === '/') {
                        proxyDomain = proxyDomain.slice(0, -1);
                    }
                    script.src = "".concat(proxyDomain, "/lib/sdk@").concat(version, "/velt.js");
                }
                else {
                    script.src = "https://cdn.velt.dev/lib/sdk@".concat(version, "/velt.js");
                }
            }
            script.id = 'veltScript';
            script.type = 'module';
            document.body.appendChild(script);
            script.onload = function () {
                // Resolve the promise when the script has loaded
                resolve();
            };
            script.onerror = function () {
                // Reject the promise if there is an error loading the script
                reject(new Error('Failed to load Velt script'));
            };
        }
        else {
            // Resolve the promise immediately if the script already exists
            resolve();
        }
    });
};
export var initVelt = function (apiKey, config) { return __awaiter(void 0, void 0, void 0, function () {
    var velt, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 7]);
                return [4 /*yield*/, loadVelt(config === null || config === void 0 ? void 0 : config.options)];
            case 1:
                _a.sent();
                velt = window.Velt;
                if (!config) return [3 /*break*/, 3];
                return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.init(apiKey, config))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.init(apiKey))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (velt === null || velt === void 0 ? void 0 : velt.st) {
                    velt === null || velt === void 0 ? void 0 : velt.st('client');
                }
                return [2 /*return*/, velt];
            case 6:
                err_1 = _a.sent();
                console.error(err_1);
                return [2 /*return*/, null];
            case 7: return [2 /*return*/];
        }
    });
}); };
export var getVeltClient = function () { return __awaiter(void 0, void 0, void 0, function () {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                if (!!window.Velt) return [3 /*break*/, 2];
                return [4 /*yield*/, loadVelt()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, window.Velt];
            case 3:
                err_2 = _a.sent();
                console.error(err_2);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
